import styled from 'styled-components';

type PortfolioHeaderResultsContainerProps = {
  isMobileDevice: boolean;
  isTablet: boolean;
};

export const PortfolioHeaderResultsContainer = styled.div<PortfolioHeaderResultsContainerProps>`
  display: flex;
  flex-direction: column;

  ${(props) =>
    props.isMobileDevice
      ? `display: -webkit-inline-box;`
      : ` flex-direction: row;
          column-gap: 5px;`}

  ${(props) => (props.isTablet ? `flex-direction: column` : ` `)}
`;
